import React, { createContext, useContext } from 'react';
const HeadingStructureAIContext = /*#__PURE__*/createContext(null);

/**
 * Access the AI context. Must be used within a HeadingStructureAIProvider.
 * @throws if used outside of the provider
 */
export const useHeadingStructureAIContext = () => {
  const context = useContext(HeadingStructureAIContext);
  if (!context) {
    throw new Error('useHeadingStructureAIContext must be used within a HeadingStructureAIProvider. ' + 'Wrap your HeadingStructureRuleFixer with <HeadingStructureAIProvider>.');
  }
  return context;
};

/**
 * Optional version — returns null when not inside a provider.
 * Used by HeadingStructureRuleFixer to gracefully degrade when
 * showFixWithAiButton is true but no provider is present.
 */
export const useOptionalHeadingStructureAIContext = () => useContext(HeadingStructureAIContext);
/**
 * Provider for the heading structure AI fix flow.
 * Wrap HeadingStructureRuleFixer with this when showFixWithAiButton={true}.
 *
 * See README.md for full integration guide.
 */
export const HeadingStructureAIProvider = _ref => {
  let {
    value,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(HeadingStructureAIContext.Provider, {
    value: value
  }, children);
};
//# sourceMappingURL=heading-structure-ai-context.js.map